import gql from "graphql-tag"

export default gql`
  fragment fullInternalProductPermissions on ProductPermissions {
    uuid
    businessId
    internal {
      finance {
        create
        createFraudThresholds
        read
        removeLinkedCards
      }
      features {
        deactivateUsers
        favouriting
        resendWelcomeEmails
        canGdprUsers
        canManageInternalUsers
        isEngineer
      }
    }
  }
`
